import Vue from 'vue'
import AppAutosizeTextarea from '../../../components/AppAutosizeTextarea'
import AppLocationAdd from '../../../components/AppLocationAdd'
import AppLocationList from '../../../components/AppLocationList'
import AppItemAdd from '../../../components/AppItemAdd'
import AppSaveLocation from '../../../components/AppSaveLocation'
import AppLocationChange from '../../../components/AppLocationChange'
import AppLocationDelete from '../../../components/AppLocationDelete'
import AppItemDelete from '../../../components/AppItemDelete'

// TODO: 無駄が多いので整理したい
import { DatePicker, TimePicker } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css'
import '../../../../../sass/common/element-variables.scss'
import ElementUIHelper from '../../../element-ui-helper'
import draggable from 'vuedraggable'

locale.use(lang)

Vue.component("app-autoresize-textarea", AppAutosizeTextarea)
Vue.component("app-location-add", AppLocationAdd)
Vue.component("app-location-change", AppLocationChange)
Vue.component("app-location-delete", AppLocationDelete)
Vue.component("app-location-list", AppLocationList)
Vue.component("app-item-add", AppItemAdd)
Vue.component("app-item-delete", AppItemDelete)
Vue.component("app-location-save", AppSaveLocation)

export default (data) => {

  data.location_init = {
    location_status: 1,
    location_name: '',
    zip: '',
    pref: 0,
    address: '',
    tel: '',
    fax: '',
    business_hours: '',
    access: '',
    map_type: 1,
    google_map_url: ''
  };

  data.location_add = Object.assign({}, data.location_init);
  data.location_current = Object.assign({}, data.location_init);
  data.max_text_count = 5;

  const vm = new Vue({
    el: '#company-content',
    data: data,
    components: {
      'draggable': draggable,
    },
    methods: {
      //--- Show add location form
      addModal: function (modal_id) {
        this.locationAdd = Object.assign({}, this.location_init);
        $('#add_location_status_1').trigger('click');
        $('#add_map_type_1').trigger('click');
        $(modal_id).modal('show');
      },
      //--- Add location
      addLocation: function (modal_id) {
        this.$set(this.locations, this.locations.length, Object.assign({}, this.locationAdd));
        this.locationAdd = Object.assign({}, this.location_init);
        $(modal_id).modal('hide');
      },
      //--- Hide add location form
      cancelAddLocation: function (modal_id) {
        $(modal_id).modal('hide');
      },
      //--- Show change location form
      changeModal: function (index, modal_id) {
        this.locationCurrent = Object.assign({}, this.locations[index]);
        $('#modify_location_status_' + index).find('#location_status_' + this.locationCurrent.location_status + '_' + index).trigger('click');
        $('#modify_map_type_' + index).find('#map_type_' + this.locationCurrent.map_type + '_' + index).trigger('click');
        $(modal_id).modal('show');
      },
      //--- Change location
      changeLocation: function (index, modal_id) {
        this.locationCurrent = Object.assign({}, this.location_init);
        $(modal_id).modal('hide');
      },
      //--- Hide change location form
      cancelChangeLocation: function (index, modal_id) {
        this.$set(this.locations, index, Object.assign({}, this.locationCurrent));
        this.locationCurrent = Object.assign({}, this.location_init);
        $('#add_location_status_1').trigger('click');
        $('#add_map_type_1').trigger('click');
        $(modal_id).modal('hide');
      },
      //--- Show delete location form
      deleteModal: function (modal_id) {
        $(modal_id).modal('show');
      },
      //--- Delete location
      deleteLocation: function (index, modal_id) {
        this.locations.splice(index, 1);
        this.locationAdd = Object.assign({}, this.location_init);
        $('#add_location_status_1').trigger('click');
        $('#add_map_type_1').trigger('click');
        $(modal_id).modal('hide');
      },
      addInput() {
        if(this.isTextMax) {
            return;
        }
        this.texts.push([]);
        Vue.nextTick(() => {
            const maxIndex = this.texts.length - 1;
        });
      },
    },
    computed: {
      option: function () {
        return function (index) {
          return {
            animation: 100,
            handle: '.drag_handle',
            ghostClass: 'ghost',
            group: 'company',
          };
        }
      },
      locationsList: {
        get() {
          return this.locations;
        },
        set(value) {
          this.locations = value;
        }
      },
      locationAdd: {
        get() {
          return this.location_add;
        },
        set(value) {
          this.location_add = value;
        }
      },
      locationCurrent: {
        get() {
          return this.location_current;
        },
        set(value) {
          this.location_current = value;
        }
      },
      maxTextCount: {
        get() {
          return this.max_text_count;
        },
        set(value) {
          this.max_text_count = value;
        }
      },
      isTextMax() {
        return (this.texts.length >= this.maxTextCount);
      },
    },
  });
}
